import { registerNamespaces } from "./dictionary";

// Site chrome — the navbar and footer render on every route, so these are the
// only namespaces worth registering up front. Everything else is registered
// per route (see app/(site)/_i18n/*), which keeps a visitor from shipping and
// evaluating the copy of pages they never open.
import enFooter from "@/locales/en/footer.json";
import enMocks from "@/locales/en/mocks.json";
import enNav from "@/locales/en/nav.json";
import thFooter from "@/locales/th/footer.json";
import thMocks from "@/locales/th/mocks.json";
import thNav from "@/locales/th/nav.json";

// There is nothing to initialise and no "current language" to hold: the locale
// is decided by the proxy before anything renders, and every lookup takes it as
// an argument. See lib/i18n/dictionary.ts.
// `mocks` is one string — the line that says a device mock-up holds demo data.
// It rides with the chrome rather than with `home` because the product pages
// draw mock-ups too, and a per-route `home` registration there would ship that
// whole namespace to a route that reads one line of it.
registerNamespaces({
  en: { footer: enFooter, mocks: enMocks, nav: enNav },
  th: { footer: thFooter, mocks: thMocks, nav: thNav },
});
